import React from 'react'
import { Text } from 'rebass'

const LabelForm = ({ children }) => (
    <Text fontSize={[2, 3, 4]} fontWeight="bold">
        {children}
    </Text>
)
export default LabelForm
